export default __webpack_public_path__ + "static/media/manual_order_logo.1a6c5567.svg";